export enum EStatusPedidoCompra {
  EmDigitacao = 1,
  EmAnalise = 2,
  Confirmado = 3,
  Entregue = 4,
  Cancelado = 5,
}
